// extracted by mini-css-extract-plugin
export default {"authorDate":"authorDate__XPpqP","wrapper":"wrapper__2U0jk","image":"image__vQCDB","info":"info__i-bmx","author":"author__Y0S5d","date":"date__JwnwC","onlyDate":"onlyDate__9X5h2"};